import __var_0__ from '@stdlib/assert/is-string';
import __var_1__ from '@stdlib/assert/is-plain-object';
import __var_2__ from '@stdlib/fs/read-file';
import __var_3__ from '@stdlib/string/remove-utf8-bom';
import __var_4__ from '@stdlib/utils/parse-json';
import __var_5__ from '@stdlib/assert/instance-of';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isString = __var_0__.isPrimitive;
var isObject = __var_1__;
var readFile = __var_2__.sync;
var removeBOM = __var_3__;
var parseJSON = __var_4__;
var instanceOf = __var_5__;


// MAIN //

/**
* Synchronously reads a file as JSON.
*
* @param {(string|Buffer|integer)} file - file path or file descriptor
* @param {(Options|string)} [options] - options
* @param {(string|null)} [options.encoding] - file encoding
* @param {string} [options.flag] - file status flag
* @param {Function} [options.reviver] - JSON reviver
* @throws {TypeError} options argument must be either a string or an object
* @returns {(JSON|Error)} JSON or an error
*
* @example
* var resolve = require( '@stdlib/vendor/path.js' ).resolve;
* var instanceOf = require( '@stdlib/assert/instance-of' );
*
* var out = readJSONSync( resolve( __dirname, '..', 'package.json' ) );
* if ( instanceOf( out, Error ) ) {
*     throw out;
* }
* console.dir( out );
*/
function readJSONSync( file, options ) {
	var opts;
	var f;
	if ( arguments.length > 1 ) {
		if ( isString( options ) ) {
			opts = {
				'encoding': options
			};
		} else {
			if ( !isObject( options ) ) {
				throw new TypeError( 'invalid argument. Options argument must be either a string or an object. Value: `' + options + '`.' );
			}
			opts = options;
		}
	} else {
		opts = {};
	}
	f = readFile( file, opts );
	if ( instanceOf( f, Error ) ) {
		return f;
	}
	f = f.toString();
	if ( opts.encoding === 'utf8' ) {
		f = removeBOM( f );
	}
	if ( opts.reviver ) {
		return parseJSON( f, opts.reviver );
	}
	return parseJSON( f );
}


// EXPORTS //
export default readJSONSync;
